import {ViewPersonalConfig} from "../../@type";
import {ViewType} from "../../../../gd/const/views/view-type";
import {PersonalViewLocation} from "../@types";

export const MY_NOTES_CONFIG : ViewPersonalConfig = {
    type            : ViewType.MY_NOTES,
    name            : 'Notepad',
    icon            : 'ii5-wiki', //'i5-document',
    iconSvg         : 'isvg-view-my-notes',
    url             : 'my-notes',
    description     : 'Simple notepad to take quick notes on the fly',
    defaultLocation : PersonalViewLocation.HOME
}
